export default {
  app: {
    sceneChange: '场景改变',
    upgrade2seniorVip2useExclusiveMaterial: '升级为高级版会员后，可使用高级版会员专属素材',
    continueEditing: '继续编辑',
    upgrade2seniorVip: '升级为高级版会员',
    upgrade2vip2useExclusiveMaterial: '升级为企业会员后，可使用会员专属素材',
    Upgrade2CorMem: '升级为企业会员',
    reduceDurationOrUpgrade2vip2export: '由于当前项目时长已经超过3.5分钟，若您需要导出，请减少时长或升级为企业会员',
    upgrade2vip2export: '您正在使用 （高级） VIP功能或资源，若您需要导出视频，还请升级会员。'
  },
  nameContent: {
    recName: '录音名称',
    inputRecTitle: '输入录音名称，有助于你方便的管理录音。',
    plzInputRecTitle: '请输入录音名称',
    recTitleRestriction: '请将名称限制在12字以内'
  },
  generateVoice: {
    AIInputWordsSynthesizeSpeech: 'AI智能-输入文字 合成语音',
    soundLib: '音库',
    speed: '语速',
    slow: '慢',
    fast: '快',
    insertPause: '插入停顿',
    s: '秒',
    frame: '画面',
    rec: '录音',
    word: '字',
    audition: '试听',
    synthesizeSpeech: '合成语音',
    comfirm: '确定',
    synthesizingSpeech: '正在合成语音',
    LinChiling: '林志玲',
    plzInputWordsHere: '请在此处输入文字',
    cantExceed150Words: '每次转换不能超过150字',
    inputHere2synthesizeSpeech: '在这里输入文字即可快速合成语音。',
    pauseRestriction: '累计添加的停顿不可超过20s',
    systemError: '系统开小差了',
    untitled: '未命名'
  },
  setUploadRecordName: {
    renameRec: '录音重命名',
    confirm: '确定'
  },
  tip: {
    turnOffTip: '关闭新手提示',
    popupTip: '气泡提示'
  },
  popup: {
    chooseMaterial2replace: '选择右边的素材可进行替换。'
  },
  hand: {
    chooseGesture: '选择手势',
    dontUseGesture: '不使用手势',
    empty: '空空如也',
    previewAfterChosenGesture: '选择好手势后，点击画布下方的“预览”可看效果哦！'
  },
  isInternet: {
    networkError: '目前作品已保存。但由于网络连接超时，暂时无法进行其他操作。网络恢复后可继续编辑作品。'
  },
  preview: {
    upgrade2export: '您使用了（高级）VIP素材和功能，若您需要导出还请升级会员',
    videoContainsVipMaterialOrFunction: '视频中含有VIP素材或功能'
  },
  quickManu: {
    workManagement: '作品管理',
    new: '新建',
    template: '模板',
    story: '故事板',
    vipService: '会员服务',
    tip: '新手提示',
    openTipsPrompt: '开启新手模式，我们会在创作过程中对难度较高的功能进行较为详细的提示。若关闭，则我们会在操作中做较为简要的提示。开启或关闭均不会影响您的创作。',
    clickHere2closeOrOpenTips: '点击这里可以关闭或开启新手提示',
    whatTipsDo: '新手提示会在每一步操作时进行较为详细的提示，帮助你快速搞定动画'
  },
  style: {
    chooseStylePrompt: '选择一个风格后，场景页、背景、道具、形状均会切换至相应的风格'
  },
  chartTextOptions: {
    isShowData: '是否显示数据',
    data: '数据',
    cateTitle: '类别标题',
    cateTitlePos: '系列标题位置',
    bottom: '下边',
    right: '右边',
    submit: '提交'
  },
  effectSetting: {
    effect: '特效',
    gesture: '手势',
    animPath: '动画路径',
    leftOut: '向左移出',
    rightOut: '向右移出',
    upOut: '向上移出',
    downOut: '向下移出',
    leftIn: '从左移入',
    rightIn: '从右移入',
    upIn: '从上移入',
    downIn: '从下移入',
    entrance: '入场',
    noAnim: '无动画',
    exit: '出场',
    previewAfterSettingInOutAnim: '设置好入场或出场动画后，点击画布下方的“预览”可看效果哦！',
    write: '书写',
    appear: '逐行出现',
    draw: '手绘',
    animPathTip: '试试拖动其中一个素材，可调整素材运动的路线；点击“小剪刀”可取消路径动画；调整时间轴上的路径动画，可调整运动的时间。',
    popIn: '放大出现',
    popOut: '缩小退出',
    fadeIn: '淡入',
    fadeOut: '淡出',
    in: '入',
    out: '出'
  },
  effectSettingText: {
    effect: '特效',
    gesture: '手势'
  },
  lottieMotionContent: {
    loading: '加载中',
    empty: '空空如也',
    notFound: '呃哦，未找到',
    successfullyLoaded: '加载成功'
  },
  propSetting: {
    color: '颜色',
    display: '文案',
    layer: '图层',
    chartType: '图表样式',
    motion: '动作',
    stick2top: '置顶',
    stick2bottom: '置底',
    moveUp: '上移',
    moveDown: '下移',
    replace: '替换',
    flip: '翻转',
    edit: '编辑'
  },
  switchChartType: {
    pie: '饼图',
    line: '折线图',
    bar: '柱状图',
    cate: '类别',
    series: '系列',
    editTip: '在表格中可以输入数据并生成图表，更新数据后记得点击“确认”才会生效哦！',
    businessTechnology: '商务科技',
    flat: '扁平简约',
    cute: '可爱清新',
    blackNwhite: '黑白手绘',
    notFound: '无此风格的图表！'
  },
  tabs: {
    prop: '属性',
    anim: '动画'
  },
  search: {
    searchHistory: '搜索历史',
    notFound: '没有找到你搜素内容哦～',
    audition: '试听',
    use: '使用',
    notFoundInThisStyle: '当前风格内没有搜索的素材哦～',
    exitSearch: '退出搜索状态',
    searchTips: '红色数字代表了我们在每个分类下找到的素材数量，点击不同分类可进行查看；删除搜索关键字或点击顶部可退出搜索状态。'
  },
  soundRecord: {
    notFound: '没有找到内容哦',
    searchMyRec: '搜索我的录音',
    uploadRec: '上传录音',
    AIDub: 'AI智能配音',
    youHave: '您共有',
    times: '次',
    rights: '免费上传录音的权益，目前还剩余',
    loading: '加载中',
    upgrade2seniorVip2useAIsynthesizeSpeech: '升级为高级企业会员后，可进行AI语音合成。即输入文字、智能合成语音。',
    upgrade2seniorVip: '开通企业会员',
    upgrade2seniorVip2UploadMoreRecs: '上传录音次数已用完，如需继续使用，还请升级为高级会员',
    upgrade2vip2uploadRec: '上传录音为会员功能，如需使用，还请升级为会员',
    upgrade2vip: '升级会员免费用',
    unTitled: '未命名',
    rec: '录音'
  },
  charactersSprite: {
    browserDontSupportVideo: '您的浏览器不支持 video 标签。',
    fail: '失败'
  },
  modifyUserItem: {
    title: '名称',
    plzInputTitle: '请输入名称',
    tag: '标签',
    plzInputTag: '请输入标签',
    isDelMaterial: '是否删除素材',
    loading: '加载中',
    cancel: '取消',
    del: '删除',
    fail: '失败',
  },
  spritesClick: {
    layerSetting: '图层设置',
    drag2changeLayer: '可拖动相应的元素，以调节其在画布中的图层顺序。',
    pic: '图片',
    text: '文字',
    animMaterial: '动画素材'
  },
  vipEquity: {
    standardVip: '企业标准版',
    exportHDvideo: '付费模板素材畅享，高清画质导出。',
    seniorVip: '高级版',
    infiniteWatermarkRemoveDraftRecovery: '无限次视频无水印，项目误删找回。',
    ultimateVip: '企业至尊版',
    infiniteUsageExclusiveService: '所有功能无限使用，专属服务支持。',
    operateOnTheCorrespondingPaymentPage: '请在相应的付款页面进行操作',
    encounterProblem: '遇到问题',
    paid: '付款成功',
  },
  vipSprites: {
    paymentFailure: '您的付款还没有成功哦',
    getHelp: '查看帮助',
    contactCustomerService: '联系客服'
  },
  bgSetting: {
    setting: '设置',
    blur: '模糊',
    opacity: '透明度'
  },
  chartSetting: {
    editData: '数据编辑'
  },
  chartTable: {
    editChart: '编辑图表',
    chartTitle: '图表标题',
    confirm2update: '点击确定后，数据才会更新至图表中',
    confirm: '确定',
    cate: '类别',
    series: '系列'
  },
  chartType: {
    chooseChartType: '选择图表样式'
  },
  colorPicker: {
    pickAcolor: '选择颜色',
    recentlyUse: '最近使用'
  },
  enterExitEffect: {
    entranceAnim: '入场动画',
    exitAnim: '出场动画',
    gesture: '手势',
    addEntranceGesture: '添加入场的手势',
    addExitGesture: '添加出场的手势',
    noAnim: '无动画',
    draw: '手绘',
    write: '书写',
    appear: '逐行出现',
    previewAfterSetting: '设置好入场或出场动画后，点击画布下方的“预览”可看效果哦！',
  },
  fontFamily: {
    chooseFontFamily: '选择字体',
    downloading: '下载中'
  },
  lottieMotion: {
    lottieMotion: '角色动作',
    generatingMotion: '正在生成动作'
  },
  sceneEffectX: {
    sceneAnim: '转场动画',
    basic: '基础型',
    executive: '华丽型',
    stylized: '特效型',
    camera: '镜头型',
    zoomIn: '放大',
    zoomOut: '缩小',
    fadeInFadeOut: '淡入淡出',
    clipboard: '电影打板',
    tvNoise: '电视雪花',
    hands: '手势下移',
    pullDown: '帘子下移',
    roller: '滚筒刷',
    sqweegee: '玻璃刮',
    poof: '爆出',
    blueColorSmear: '蓝色涂抹',
    whiteColorSmear: '白色涂抹',
    fanUp: '扇叶向上',
    fanDown: '扇叶向下',
    spiralzTech: '蓝色螺旋',
    spiralz: '灰色螺旋',
    swipe: '横向划出',
    sliceVertical: '垂直划像',
    sliceHorizontal: '水平划像',
    sliceCenter: '中间划像',
    slice: '对角划像',
    cameraUp: '镜头上移',
    cameraDown: '镜头下移',
    cameraLeft: '镜头左移',
    cameraRight: '镜头右移',
    slideRight: '从左移入',
    slideLeft: '从右移入',
    slideDown: '从上移入',
    slideUp: '从下移入'
  },
  scenesSetting: {
    copy: '复制',
    collect: '收藏',
    copyLastFrame: '复制最后一帧画面'
  },
  shortcuts: {
    shortcut: '快捷键',
    copy: '复制',
    cut: '剪切',
    paste: '粘贴',
    del: '删除',
    moveUp: '上移',
    moveDown: '下移',
    moveLeft: '左移',
    moveRight: '右移',
    multiSelect: '多选',
    click: '单击',
    editText: '编辑文字',
    dblclickBlankSpace: '双击空白区',
    ifUseMac: '备注：如果您使用的Mac',
    replaceCtrlWithCommand: '请将CTRL切换为Command',
  },
  spriteRightKey: {
    stick2bottom: '置于底层',
    stick2top: '置于顶层',
    layerSetting: '图层设置'
  },
  textSetting: {
    fontFamily: '字体',
    fontSize: '大小',
    color: '颜色',
    style: '样式',
    align: '对齐',
    layer: '图层',
    stick2top: '置顶',
    stick2bottom: '置底',
    moveUp: '上移',
    moveDown: '下移',
    anim: '动画'
  },
  uploadFile: {
    pic: '图片',
    bgPic: '背景图片',
    rec: '录音',
    bgm: '背景音乐',
    uploadStandard: '上传标准',
    picRestriction: '图片：可上传10M以内的PNG/JPG/JPEG',
    recRestriction: '录音：可上传20M以内的MP3，上传后可添加至单个页面。该功能为会员专属。',
    bgmRestriction: '背景音乐：可上传20M以内的MP3，上传后可添加至整个视频。',
    upgrade2seniorVip2uploadMoreRecs: '上传录音次数已用完，如需继续使用，还请升级为高级会员',
    upgrade2seniorVip: '开通企业会员',
    upgrade2vip2uploadRec: '上传录音为会员功能，如需使用，还请升级为会员',
    upgrade2vip: '升级会员免费用'
  },
  volume: {
    volControl: '音量调节',
    allScenes: '全部页面',
    music: '音乐',
    bgmNotFound: '暂无背景音乐',
    currentScene: '当前页面',
    audition: '试听',
    recNotFound: '暂无录音',
    unTitled: '未命名'
  },
  bg: {
    bgColor: '背景颜色',
    uploadBg: '上传背景',
    picUploadRestriction: '请上传PNG/JPG/JPEG格式的图片，大小不超过10M',
    expandNcollapse: '点击可展开/收起',
    hereIsUploadedPic: '在这里可以看到上传的图片。'
  },
  personal: {
    picUploadRestriction: '请上传PNG/JPG/JPEG格式的图片，大小不超过10M',
    collectCurrentScene: '收藏当前场景',
    uploadVideo: '上传视频',
    comingSoon: '即将上线，敬请期待',
    scene: '场景页',
    deletedWorks: '已删除作品',
    upgrade2vip2collect: '该场景页为VIP素材，如需收藏，还请升级为会员。',
    upgrade2vip: '升级为企业会员',
    myScene: '我的场景页',
    collectSceneSuccessfully: '收藏场景成功',
    hereIsCollectedScenes: '收藏的场景页都可以在这里找到。',
    upgrade2seniorVip2UploadMoreRecs: '上传录音次数已用完，如需继续使用，还请升级为高级会员',
    upgrade2seniorVip: '开通企业会员',
    upgrade2vip2uploadRec: '上传录音为会员功能，如需使用，还请升级为会员',
    upgrade2vip: '升级会员免费用'
  },
  scenes: {
    collectCurrentScene: '收藏当前场景'
  },
  shapes: {
    chart: '图表'
  },
  sound: {
    currentBgm: '当前背景音乐/录音',
    loop: '循环',
    volControl: '音量调节',
    mp3Restriction: '支持MP3格式上传，大小不超过20M',
    hereIsUploadedBgm: '在这里可以看到上传的背景音乐。',
    hereIsUploadedRecs: '在这里可以看到上传的录音。',
    fail2loadAudio: '加载音频出错',
    settingBgmHere: '已将该音乐添加至整个视频中，在这里可以看到当前添加的背景音乐，并对音量和循环操作进行设置。'
  },
  text: {
    addTitle: '添加标题',
    addSubtitle: '添加副标题',
    addBodyText: '添加正文'
  },
  btns: {
    try2addScene: '试试添加场景页',
    sound: '声音',
    mine: '我的'
  },
  tip: {
    addingBgVideo: '正在添加视频背景'
  },
  selection: {
    addEntranceAnim: '点击可添加入场动画',
    addExitAnim: '点击可添加出场动画',
    changeEntranceTime: '拖动小黑线，可改变素材的入场时间',
    changeExitTime: '拖动小黑线，可改变素材的出场时间',
    timeExceeded: '数据错误，元素时间超出总时间'
  },
  bgSettingBtn: {
    networkError: '视频背景加载失败，请检查网络'
  },
  editor: {
    'loading': '正在加载',
    'videoContainsVipMaterial': '视频中含有VIP素材或功能',
    'loadFailure': '加载失败'
  },
  editorBtn: {
    undo: '撤销',
    redo: '返回',
    AIDub: 'AI智能配音',
    AIdraw: 'AI智能绘图',
    grid: '网格线',
    upgrade2vip2export: '您使用了（高级）VIP功能或资源，若您需要导出视频还请升级会员',
    operateOnTheCorrespondingPaymentPage: '请在相应的付款页面进行操作',
    encounterProblem: '遇到问题',
    paid: '付款成功'
  },
  setPathAnim: {
    delAnimPath: '删除路径动画'
  },
  spriteBtn: {
    chooseMaterial2replace: '选择右边的素材可进行替换。',
    switchChartType: '切换图表'
  },
  timeline: {
    previewCurrentScene: '预览当前页面',
    timeline: '时间轴',
    checkEveryFrame: '移动小三角，可查看视频的每个画面',
    increaseTime: '添加时间',
    editInTheNextScene: '每页最多可添加时长20秒的视频。您也可以在下一页继续创作',
    reduceTime: '减少时间',
    upgrade2vip2createLongerVideo: '时长在3.5分钟内的视频传播更佳。如需制作时长更长的作品，请升级为企业会员。',
    upgrade2vip: '升级为企业会员',
    timelineBtnUsage: '点击“+”或“-”可修改每一页的时间，每页最长的动画时间为20秒。'
  },
  memberFooter: {
    upgrade2vip2export: '您使用了（高级）VIP素材或功能，如后续需要导出还请升级会员。',
    confirm: '确定',
    upgrade2vip2export: '升级会员 免费导出',
    upgrade2seniorVip2export: '开通企业会员 免费导出',
    upgrade2ultimateVip2export: '升级至尊版会员 免费导出'
  },
  coverDialog: {
    chooseCover: '选取封面',
    coverExceedRestriction: '截取的封面已经超出10MB限制'
  },
  exportDialog: {
    settingExportInfo: '设置导出信息',
    replace: '替换',
    cover: '封面',
    title: '标题',
    tag: '标签',
    intro: '简介',
    watermark: '水印',
    definition: '清晰度',
    myWork: '我的作品',
    goodTitleCanAttractAudience: '好的标题可吸引更多的观众来看',
    plzInputTitle: '请填写标题',
    inputTags: '填写标签便于检索，最多不超过5个，点击Enter隔开多个标签',
    tagsRestriction: '请填写标签，每个标签最多8个汉字或16个字母',
    makeVideoLikePPT: '做视频像做PPT一样简单？快挪步到“来画动画”一探究竟吧！',
    introCanTellMoreInfo: '简介可展示关于视频的更多背景信息或内容哦',
    plzInputIntro: '请填写简介',
    defaultWatermark: '默认水印',
    noWatermark: '无水印',
    customWatermark: '自定义水印',
    youHave: '您共有',
    removeWatermark: '去除水印',
    customWatermark: '次自定水印',
    times: '次',
    rights: '的权益，目前还剩余',
    hd: '高清',
    uhd: '超清',
    chosenPicExceedRestriction: '选中图片已经超出10MB限制',
    upgrade2vip2removeWatermark: '升级为会员后，可去除或自定义水印。',
    upgrade2vip2useFreely: '升级会员免费用',
    upgrade2vip2customWatermark: '升级为会员后，可自定义水印。',
    upgrade2vip2exportHighDefinitionVideo: '升级为会员后，可进行导出高画质（720P/1080P）的视频',
    upgrade2vip: '升级为会员',
    submitting: '正在提交数据',
    submitSuccessfully: '提交数据成功',
    submitFailed: '提交数据失败',
    removeWatermark: '去除水印',
    customWatermark: '自定义水印',
    workCate: '作品分类',
    plzSelectCate: '请选择分类',
    plzSelectCateForReleasedWork: '请选择发布作品的分类',
    isReleaseAsContest: '是否发布为大赛作品',
    teacher: '指导老师',
    teacherName: '指导老师姓名',
    plzInputTeacher: '请填写指导老师',
    teachersContactInfo: '指导老师联系方式',
    teachersTelOrEmail: '指导老师联系方式（电话或者邮箱）',
    plzInputTeachersContactInfo: '请填写指导老师联系方式',
    onlyOneReleaseAllowed: '您只能发布一次大赛作品',
    confirm2release: '发布后不能更改作品信息，确认发布吗？',
    released: '您已发布过大赛作品',
    missDeadline: '您报名的赛区已截止投稿，如需帮助请联系官方客服',
    notSignUpPrompt: '您还未报名大赛，请先报名后再进行发布作品，或者取消勾选大赛',
    signUp: '前往报名'
  },
  savingMask: {
    saving: '正在保存中'
  },
  Draw: {
    recommendUwpApp: '建议下载”来画动画”Win10客户端，体验更极致的绘画体验',
    figureIdentification: '图形自动识别',
    closeIntelligentRecommendation: '关闭智能推荐',
    saveCurrentWork: '保存当前绘画作品',
    finishDraw: '完成绘画',
    redrawPic: '重新绘制图形',
    redraw: '重画',
    exitAndDontSave: '退出后将不保留当前绘画作品',
    exitDraw: '退出绘画',
    isSaveCurrentDraw: '是否保存当前绘画？',
    exitDirectly: '直接退出',
    saveNexit: '保存并退出',
    myPainting: '我的绘画',
    upgrade2seniorVip2getAIdraw: '升级为高级企业会员后，可进行AI智能绘画。',
    upgrade2seniorVip2useByFree: '开通企业会员'
  },
  Guidance: {
    welcome2laihua: '欢迎来到来画动画，开启你的动画创作之旅。',
    fewTips2learn2createAnim: '几个小技巧，帮你快速get到动画创作',
    openNow: '立即开启',
    skip: '跳过',
    nickname: '王小二',
    laihuaer: '来画君',
    next: '下一步'
  },
  RightNav: {
    chooseStyle: '选择风格',
    chooseStylePrompt: '选择一个风格后，场景页、背景、道具、形状均会切换至相应的风格。'
  },
  Scenes: {
    addAnimBetweenScenes: '转场动画，在两个页面间添加动画效果',
    addScene: '添加场景页'
  },
  topnav: {
    quickManu: '快捷菜单',
    preview: '预览',
    tutorial: '教程',
    export: '导出',
    save2myDraft: '保存至我的项目',
    previewAll: '预览整个视频',
    shareOrDownloadAfterExport: '导出后可分享或下载',
    saved: '已保存',
    saveCoverFailed: '保存封面失败',
    saveFailed: '保存失败',
    failed2getDraft: '获取作品项目失败',
    dataNotRequest: '未取得作品数据',
    upgrade2vip2exportLongerVideo: '升级为会员后，导出视频时长可超过3.5分钟',
    upgrade2vip: '升级为会员',
    clickRightPart2addMaterial: '您还没有添加任何素材哦，请点击右侧部分添加',
    logoutPrompt: '退出登录提示',
    autoLogoutPrompt: '您的账号所登录的设备已超出数量限制，当前账号已自动退出登录。',
    draftSaved: '我们已保存您的当前项目，重新登录后可在“作品管理-我的项目”中查看。',
    securityWarning: '若存在账号和密码泄露的风险，还请至“个人中心-账号设置”中修改密码。'
  },
  Upload: {
    plzUploadPicFile: '请上传图片文件',
    finished: '已完成：',
    plzUploadMp3File: '请上传mp3文件',
    plzChooseSmallerFile: '请选择小于20MB的文件',
    bgNPropRestriction: '背景，道具素材上传需限制在10MB内。',
    watermarkRestriction: '水印素材上传需限制在200KB内。',
    uploadFailedPlzcheckNetworkOrFileFormat: '上传错误！请检查网络或文件格式',
    uploading: '正在上传文件',
    uploadFailedPlzTryAgain: '文件上传错误，请重试！'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-cn.js